import React, { useEffect } from 'react';
import { Outlet, useNavigate, useParams } from 'react-router-dom';
import '@fortawesome/fontawesome-free/css/all.min.css';

import './Login.scss';
import Notification from '../../Components/Notification';
import PageNotSpotted from '../../Components/PageNotSpotted';
import Loader from '../../Components/Loader';
import { UserType } from '../../Utils';
import { useGameReducer } from '../../Store';
import { ChangeLanguageButton } from '../../Components/dialogs/ChangeLanguage/ChangeLanguageButton';
import { Play60s } from '../../Components/LuckyMinute/LuckyMinute';
import { UserActions } from '../../Store/Actions';
import { useTranslation } from 'react-i18next';

export const Login =  () => {
  const navigate = useNavigate();

  const { code } = useParams();
  const codeMode = location.pathname.includes('/Login/Password');

  const gameReducer = useGameReducer();
  const { t } = useTranslation();

  useEffect(() => {
    if (gameReducer.token) {
      UserActions.getUserDetails();
    }
  }, [gameReducer.token]);

  useEffect(() => {
    if (gameReducer.userDetail) {
      const userRole = gameReducer.userDetail.role;
      if (userRole === UserType.AGENT) {
        navigate('/Agent');
      } else if (userRole === UserType.MANAGER) {
        navigate('/Manager');
      } else {
        navigate('/App');
      }
    }
  }, [gameReducer.userDetail]);

  return (
    <div className='page_container no_header login'>
      <Notification />
      <div className='page_content'>
        {!code && (
          <div className='toggle'>
            <button className='outlined faded' onClick={() => navigate(codeMode ? '/Login' : '/Login/Password')}>{codeMode ? t('login.accessCode') : t('login.password')}</button>
          </div>
        )}

        <Play60s large={true} />
        <img className='profile_pic' src='/logo512.png' alt='login' />

        <Outlet />

        <ChangeLanguageButton />

        {gameReducer.loading && <Loader />}
      </div>
      <PageNotSpotted />
    </div>
  );
};
